export const steps_image1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fillRule="evenodd"
    strokeMiterlimit="10"
    clipRule="evenodd"
    viewBox="0 0 456 494"
  >
    <g transform="translate(-24.864 -31.593)">
      <g>
        <path
          fill="#E7F0F1"
          fillRule="nonzero"
          d="M0 62.804C-7.049 44.992-9.785 27.407-4.526 5.052-.249-13.127 6.433-30.905 7.652-49.541c7.103-108.569-58.018-141.483-134.976-115.571-24.66 8.303-79.225 24.868-105.762 26.875-48.796 3.69-80.473-11.68-108.515-12.09-49.904-.728-92.885 67.016-66.045 111.767 8.715 14.532 14.572 31.719 25.791 44.419 23.749 26.882 32.488 62.324 23.409 97.27-5.683 21.877-14.873 42.946-17.687 65.373-5.758 45.897 27.33 83.253 73.205 84.313 43.899 1.013 81.281-25.782 120.449-41.495 19.393-7.78 39.663-13.204 60.722-11.344 25.17 2.223 47.821 15.039 73.435 16.375 32.386 1.688 65.825-14.687 77.612-46.238 10.679-28.585-2.636-55.206-16.101-80.096-5.155-9.53-9.7-18.4-13.189-27.213"
          transform="translate(440.766 215.497)"
        ></path>
        <path
          fill="#C4D5D7"
          fillRule="nonzero"
          d="M0-115.265c-5.072-12.817-7.891-25.526-7.125-39.97-5.079 8.652-7.467 18.501-6.422 28.984 1.498 15.02 9.415 28.171 16.221 41.29 6.551 12.626 12.171 26.078 11.138 40.602-.949 13.33-6.405 26.271-15.957 35.684C-18.22 7.169-41.171 12.072-61.077 21.194c-6.251 2.865-12.706 6.294-17.701 11.155 9.905 2.896 19.93 5.384 30.456 5.933C-15.936 39.97 17.503 23.595 29.29-7.956c10.679-28.585-2.636-55.206-16.101-80.096-5.155-9.53-9.7-18.4-13.189-27.213"
          opacity="0.38"
          transform="translate(440.766 393.566)"
        ></path>
        <path
          fill="#E3ECFD"
          fillRule="nonzero"
          d="M-52.144-52.144c-10.305 0-18.659 23.345-18.659 52.144 0 28.798 8.354 52.144 18.659 52.144S-33.484 28.798-33.484 0c0-28.799-8.355-52.144-18.66-52.144"
          transform="matrix(0 -1 -1 0 121.021 10.856)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#fff"
          strokeWidth="1"
          d="M-93.251-15.895c21.472 24.947 92.342 20.98 91.174 0"
          transform="scale(-1 1) rotate(-7.708 449.048 616.243)"
        ></path>
        <path
          fill="#E3ECFD"
          fillRule="nonzero"
          d="M-52.143-52.143c-10.305 0-18.659 23.345-18.659 52.144 0 28.797 8.354 52.142 18.659 52.142S-33.484 28.798-33.484.001c0-28.799-8.354-52.144-18.659-52.144"
          transform="matrix(0 -1 -1 0 422.993 48.362)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#fff"
          strokeWidth="1"
          d="M-93.252-15.895c21.472 24.946 92.343 20.98 91.175 0"
          transform="scale(-1 1) rotate(-7.707 576.452 2876.418)"
        ></path>
        <path
          fill="#E3ECFD"
          fillRule="nonzero"
          d="M-52.144-52.144c-10.305 0-18.659 23.346-18.659 52.144s8.354 52.144 18.659 52.144S-33.484 28.798-33.484 0s-8.355-52.144-18.66-52.144"
          transform="matrix(0 -1 -1 0 327.433 -1.824)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#fff"
          strokeWidth="1"
          d="M0 3.535C-18.937-7.75-44.129-11.826-90.351-8.693c0 0 49.09-4.543 78.266 25.464"
          transform="translate(379.544 46.332)"
        ></path>
        <use
          width="354.476"
          height="237.325"
          x="14.545"
          y="52.635"
          transform="translate(24.864 31.593) scale(.99852 .99716)"
          xlinkHref="#_Image1"
        ></use>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M0 237.169l-336.617.079a8.903 8.903 0 01-8.905-8.901l-.053-219.441A8.904 8.904 0 01-336.674 0L-.058-.078a8.905 8.905 0 018.907 8.901L8.9 228.264a8.901 8.901 0 01-8.9 8.905"
          transform="translate(389.892 80.262)"
        ></path>
        <path
          fill="#757073"
          d="M52.554 376.092H393.86300000000006V377.21799999999996H52.554z"
          transform="matrix(-1 0 0 1 446.417 -253.31)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#E3ECFD"
          strokeWidth="2"
          d="M0 0h55.464"
          transform="translate(331.356 139.755)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#E3ECFD"
          strokeWidth="2"
          d="M0 0h55.464"
          transform="translate(331.356 162.556)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#E3ECFD"
          strokeWidth="2"
          d="M0 0h55.464"
          transform="translate(331.356 185.356)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#E3ECFD"
          strokeWidth="2"
          d="M0 0h55.464"
          transform="translate(331.356 208.156)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#E3ECFD"
          strokeWidth="2"
          d="M0 0h55.464"
          transform="translate(331.356 230.957)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#E3ECFD"
          strokeWidth="2"
          d="M0 0h55.464"
          transform="translate(331.356 253.757)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#E3ECFD"
          strokeWidth="2"
          d="M0 0h55.464"
          transform="translate(331.356 276.557)"
        ></path>
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#E3ECFD"
          strokeWidth="2"
          d="M0 0h55.464"
          transform="translate(331.356 299.357)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 171.384 176.592)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 171.391 202.207)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.005H-0.004000000000001336V23.252000000000002H-24.763z"
          transform="matrix(-1 .00028 .00028 1 171.397 227.823)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 131.776 176.603)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.005H-0.004000000000001336V23.252000000000002H-24.763z"
          transform="matrix(-1 .00028 .00028 1 131.782 202.219)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 131.789 227.831)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 92.167 176.613)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.003H-0.0030000000000001137V23.253H-24.763z"
          transform="matrix(-1 .00024 .00024 1 171.378 150.979)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.003H-0.0030000000000001137V23.253H-24.763z"
          transform="matrix(-1 .00024 .00024 1 131.769 150.989)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 92.16 150.999)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.003H-0.0030000000000001137V23.253H-24.763z"
          transform="matrix(-1 .00024 .00024 1 92.174 202.228)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.005H-0.004000000000001336V23.252000000000002H-24.763z"
          transform="matrix(-1 .00028 .00028 1 92.18 227.843)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 92.187 253.455)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 52.558 176.623)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 52.551 151.009)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.003H-0.0030000000000001137V23.253H-24.763z"
          transform="matrix(-1 .00024 .00024 1 52.565 202.238)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.003H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 52.572 227.852)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.005H-0.004000000000001336V23.252000000000002H-24.763z"
          transform="matrix(-1 .00028 .00028 1 52.577 253.467)"
        ></path>
        <path
          fill="#FF8D72"
          d="M-24.763 -0.003H-0.0030000000000001137V23.253H-24.763z"
          transform="matrix(-1 .00024 .00024 1 210.987 150.969)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.003H-0.0030000000000001137V23.253H-24.763z"
          transform="matrix(-1 .00024 .00024 1 210.993 176.583)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 211 202.196)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 211.007 227.811)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.005H-0.004000000000001336V23.252000000000002H-24.763z"
          transform="matrix(-1 .00028 .00028 1 250.595 150.96)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.003H-0.0030000000000001137V23.253H-24.763z"
          transform="matrix(-1 .00024 .00024 1 250.602 176.573)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 250.608 202.186)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.005H-0.004000000000001336V23.252000000000002H-24.763z"
          transform="matrix(-1 .00028 .00028 1 250.615 227.802)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.002H-0.0030000000000001137V23.254H-24.763z"
          transform="matrix(-1 .00024 .00024 1 290.204 150.948)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.003H-0.0030000000000001137V23.253H-24.763z"
          transform="matrix(-1 .00024 .00024 1 290.211 176.563)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.763 -0.003H-0.0030000000000001137V23.253H-24.763z"
          transform="matrix(-1 .00024 .00024 1 290.217 202.177)"
        ></path>
        <path
          fill="#E3ECFD"
          d="M-24.764 -0.002H-0.0030000000000001137V23.254H-24.764z"
          transform="matrix(-1 .00024 .00024 1 290.223 227.79)"
        ></path>
        <g fill="#F0522C" fillRule="nonzero">
          <path d="M54.916 115.265v-9.71h1.859l5.729 6.991h-.902v-6.991h2.22v9.71h-1.845l-5.743-6.991h.902v6.991h-2.22zM70.84 115.431a5.92 5.92 0 01-2.129-.374 5.04 5.04 0 01-1.692-1.054 4.827 4.827 0 01-1.11-1.596 4.992 4.992 0 01-.395-1.997c0-.721.132-1.387.395-1.997a4.764 4.764 0 011.117-1.596 5.141 5.141 0 011.692-1.054 5.8 5.8 0 012.108-.374 5.79 5.79 0 012.116.374c.642.25 1.202.601 1.678 1.054a4.92 4.92 0 011.117 1.589c.268.605.402 1.273.402 2.004 0 .721-.134 1.389-.402 2.004a4.812 4.812 0 01-1.117 1.596 5.144 5.144 0 01-1.678 1.047 5.77 5.77 0 01-2.102.374zm-.014-1.914c.435 0 .835-.074 1.2-.222a2.895 2.895 0 001.609-1.623c.153-.379.229-.8.229-1.262 0-.462-.076-.883-.229-1.262a2.953 2.953 0 00-.638-.985 2.78 2.78 0 00-.964-.638 3.22 3.22 0 00-1.207-.222c-.434 0-.834.074-1.199.222a2.895 2.895 0 00-1.609 1.623c-.153.379-.229.8-.229 1.262 0 .453.076.872.229 1.255.152.384.365.715.638.992.272.278.594.49.964.638.37.148.772.222 1.206.222zM80.425 115.265l-4.189-9.71h2.428l3.662 8.6h-1.429l3.717-8.6h2.234l-4.203 9.71h-2.22zM89.719 109.467h4.674v1.747h-4.674v-1.747zm.166 3.995h5.285v1.803h-7.518v-9.71h7.338v1.803h-5.105v6.104zM96.96 115.265v-9.71h1.858l4.134 6.852h-.985l4.064-6.852h1.845l.028 9.71h-2.109l-.013-6.478h.388l-3.246 5.451h-1.012l-3.316-5.451h.472v6.478H96.96zM110.206 115.265v-9.71h4.744c1.221 0 2.139.231 2.754.694.615.462.922 1.072.922 1.831 0 .508-.125.95-.374 1.324-.25.375-.592.664-1.027.867-.434.204-.934.305-1.498.305l.264-.568c.61 0 1.151.099 1.623.298.471.199.839.492 1.102.881.264.388.396.864.396 1.428 0 .833-.329 1.482-.985 1.949-.657.467-1.623.701-2.899.701h-5.022zm2.234-1.692h2.621c.583 0 1.025-.095 1.325-.285.301-.189.451-.492.451-.908 0-.407-.15-.71-.451-.909-.3-.199-.742-.298-1.325-.298h-2.788v-1.637h2.4c.546 0 .964-.095 1.255-.284.292-.19.437-.479.437-.867 0-.379-.145-.664-.437-.853-.291-.19-.709-.285-1.255-.285h-2.233v6.326zM122.885 109.467h4.674v1.747h-4.674v-1.747zm.166 3.995h5.285v1.803h-7.518v-9.71h7.338v1.803h-5.105v6.104zM130.125 115.265v-9.71h4.203c.87 0 1.619.141 2.247.423.629.282 1.115.687 1.457 1.214.342.527.513 1.156.513 1.886 0 .722-.171 1.344-.513 1.866-.342.522-.828.922-1.457 1.2-.628.277-1.377.416-2.247.416h-2.954l.999-.985v3.69h-2.248zm6.173 0l-2.427-3.523h2.399l2.455 3.523h-2.427zm-3.925-3.44l-.999-1.054h2.829c.694 0 1.212-.151 1.554-.451.342-.301.513-.715.513-1.242 0-.536-.171-.952-.513-1.248-.342-.296-.86-.444-1.554-.444h-2.829l.999-1.068v5.507z"></path>
        </g>
        <path
          fill="#757173"
          fillRule="nonzero"
          d="M82.566 114.364l-1.137-3.018 42.316-5.696h22.738l-38.149 5.245-11.368 1.549-14.4 1.92zm-18.317 2.582V105.65h20.338v11.296H64.249zm60.507 0l-31.453-4.922 13.389-1.856 41.938 6.778h-23.874z"
          transform="matrix(.09896 -.00003 .0002 .77465 95.485 49.085)"
        ></path>
        <g fill="#757173" fillRule="nonzero">
          <path
            d="M76.71 117.139c-4.105 0-8.039-.121-11.802-.363s-6.793-.556-9.09-.944l4.031-1.968c2.2.344 4.802.626 7.808.847 3.005.22 6.047.331 9.126.331 2.346 0 4.24-.052 5.682-.154 1.441-.102 2.504-.244 3.188-.427.685-.183 1.027-.393 1.027-.63 0-.301-.538-.54-1.613-.718-1.075-.177-2.492-.322-4.252-.435a362.13 362.13 0 00-5.828-.323 283.91 283.91 0 01-6.377-.379 94.335 94.335 0 01-5.828-.581c-1.76-.237-3.189-.549-4.289-.936-1.099-.387-1.649-.882-1.649-1.485 0-.645.794-1.234 2.382-1.767 1.589-.532 3.983-.957 7.184-1.274 3.201-.318 7.221-.476 12.059-.476 3.226 0 6.403.083 9.53.25 3.128.166 5.889.417 8.284.75l-3.665 1.985c-2.395-.301-4.79-.525-7.184-.67a116.485 116.485 0 00-7.038-.218c-2.297 0-4.178.059-5.645.178-1.466.118-2.516.271-3.152.46-.635.188-.953.406-.953.653 0 .291.538.525 1.613.702 1.075.178 2.492.32 4.252.428 1.759.107 3.702.215 5.828.323 2.126.107 4.252.231 6.377.371 2.126.139 4.069.328 5.828.564 1.76.237 3.189.549 4.289.936 1.099.388 1.649.877 1.649 1.469 0 .634-.806 1.215-2.419 1.742-1.613.528-4.02.952-7.221 1.275-3.201.323-7.245.484-12.132.484zM103.32 116.946v-1.695l31.742-8.423 1.466.952h-32.621v-2.13h43.178v1.695l-31.669 8.423-1.466-.952h34.234v2.13H103.32z"
            transform="matrix(.17052 -.00004 .0002 .77465 126.743 49.086)"
          ></path>
        </g>
        <g fill="#757173" fillRule="nonzero">
          <path
            d="M76.71 117.139c-4.105 0-8.039-.121-11.802-.363s-6.793-.556-9.09-.944l4.031-1.968c2.2.344 4.802.626 7.808.847 3.005.22 6.047.331 9.126.331 2.346 0 4.24-.052 5.682-.154 1.441-.102 2.504-.244 3.188-.427.685-.183 1.027-.393 1.027-.63 0-.301-.538-.54-1.613-.718-1.075-.177-2.492-.322-4.252-.435a362.13 362.13 0 00-5.828-.323 283.91 283.91 0 01-6.377-.379 94.335 94.335 0 01-5.828-.581c-1.76-.237-3.189-.549-4.289-.936-1.099-.387-1.649-.882-1.649-1.485 0-.645.794-1.234 2.382-1.767 1.589-.532 3.983-.957 7.184-1.274 3.201-.318 7.221-.476 12.059-.476 3.226 0 6.403.083 9.53.25 3.128.166 5.889.417 8.284.75l-3.665 1.985c-2.395-.301-4.79-.525-7.184-.67a116.485 116.485 0 00-7.038-.218c-2.297 0-4.178.059-5.645.178-1.466.118-2.516.271-3.152.46-.635.188-.953.406-.953.653 0 .291.538.525 1.613.702 1.075.178 2.492.32 4.252.428 1.759.107 3.702.215 5.828.323 2.126.107 4.252.231 6.377.371 2.126.139 4.069.328 5.828.564 1.76.237 3.189.549 4.289.936 1.099.388 1.649.877 1.649 1.469 0 .634-.806 1.215-2.419 1.742-1.613.528-4.02.952-7.221 1.275-3.201.323-7.245.484-12.132.484zM103.32 116.946v-1.695l31.742-8.423 1.466.952h-32.621v-2.13h43.178v1.695l-31.669 8.423-1.466-.952h34.234v2.13H103.32z"
            transform="matrix(.17052 -.00004 .0002 .77465 246.188 49.086)"
          ></path>
        </g>
        <path
          fill="#FF8D72"
          fillRule="nonzero"
          d="M89.671 116.946L52.662 105.65h21.446l32.352 10.005H93.838l32.842-10.005h19.73l-37.132 11.296H89.671z"
          transform="matrix(.102 -.00003 .0002 .77465 292.469 49.085)"
        ></path>
        <g fill="#757173" fillRule="nonzero">
          <path
            d="M81.893 117.139c-3.634 0-7.01-.142-10.128-.427-3.117-.285-5.82-.691-8.108-1.219-2.288-.527-4.071-1.145-5.35-1.855-1.278-.71-1.918-1.49-1.918-2.34 0-.85.64-1.63 1.918-2.34 1.279-.71 3.073-1.328 5.383-1.855 2.311-.528 5.014-.934 8.109-1.219 3.095-.285 6.482-.427 10.161-.427 4.082 0 7.772.169 11.069.508 3.298.339 6.068.836 8.311 1.493l-6.999 1.549c-1.615-.441-3.409-.772-5.383-.993-1.974-.22-4.127-.331-6.46-.331-2.198 0-4.217.086-6.056.259-1.839.172-3.432.419-4.778.742-1.345.323-2.388.704-3.129 1.146-.74.441-1.11.93-1.11 1.468 0 .538.37 1.027 1.11 1.468.741.441 1.784.823 3.129 1.146 1.346.323 2.939.57 4.778.742 1.839.172 3.858.258 6.056.258 2.333 0 4.486-.11 6.46-.33 1.974-.221 3.768-.557 5.383-1.009l6.999 1.549c-2.243.656-5.013 1.157-8.311 1.501-3.297.344-7.009.516-11.136.516zM123.882 117.139c-3.768 0-7.379-.121-10.834-.363-3.454-.242-6.235-.556-8.344-.944l3.701-1.968c2.019.344 4.408.626 7.167.847 2.759.22 5.551.331 8.378.331 2.153 0 3.891-.052 5.215-.154 1.323-.102 2.299-.244 2.927-.427.628-.183.942-.393.942-.63 0-.301-.494-.54-1.481-.718-.987-.177-2.287-.322-3.902-.435a305.961 305.961 0 00-5.35-.323 239.166 239.166 0 01-5.854-.379 79.713 79.713 0 01-5.35-.581c-1.615-.237-2.927-.549-3.937-.936-1.009-.387-1.514-.882-1.514-1.485 0-.645.729-1.234 2.187-1.767 1.458-.532 3.656-.957 6.595-1.274 2.938-.318 6.628-.476 11.069-.476 2.961 0 5.877.083 8.748.25 2.871.166 5.406.417 7.604.75l-3.365 1.985a94.38 94.38 0 00-6.594-.67 98.17 98.17 0 00-6.46-.218c-2.109 0-3.836.059-5.181.178-1.346.118-2.311.271-2.894.46-.583.188-.875.406-.875.653 0 .291.494.525 1.481.702.987.178 2.288.32 3.903.428 1.615.107 3.398.215 5.349.323 1.952.107 3.903.231 5.854.371a73.07 73.07 0 015.35.564c1.615.237 2.927.549 3.937.936 1.009.388 1.514.877 1.514 1.469 0 .634-.741 1.215-2.221 1.742-1.48.528-3.69.952-6.628 1.275-2.938.323-6.651.484-11.137.484z"
            transform="matrix(.18576 -.00005 .0002 .77465 165.911 48.625)"
          ></path>
        </g>
        <path
          fill="#757173"
          fillRule="nonzero"
          d="M64.935 116.946V105.65h40.779c8.433 0 15.701.164 21.802.492 6.101.328 10.811.799 14.131 1.412 3.32.614 4.98 1.345 4.98 2.195 0 .839-1.66 1.565-4.98 2.178-3.32.613-8.03 1.084-14.131 1.412-6.101.328-13.369.492-21.802.492H77.048l9.69-1.178v4.293H64.935zm21.803-4.002l-9.69-1.243h27.454c6.73 0 11.754-.172 15.074-.516 3.319-.344 4.979-.823 4.979-1.436 0-.624-1.66-1.108-4.979-1.452-3.32-.345-8.344-.517-15.074-.517H77.048l9.69-1.242v6.406z"
          transform="matrix(.09288 -.00002 .0002 .77465 214.026 48.613)"
        ></path>
        <path
          fill="#757173"
          fillRule="nonzero"
          d="M124.882 105.65h20.464v11.296h-20.464V105.65zm-40.169 11.296H64.249V105.65h20.464v11.296zm41.685-4.631H83.197v-2.211h43.201v2.211z"
          transform="matrix(.09896 -.00003 .0002 .77465 54.414 48.996)"
        ></path>
        <path
          fill="#777273"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.226 0 1.957-.012l.044-8.56-2.011-.01.01-2.012z"
          transform="translate(60.984 168.096)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.216 1.216 0 00-.344-.887c-.231-.239-.527-.359-.891-.361-.666-.003-1.299.468-1.897 1.412L-4.61-4.153c.498-.764 1.042-1.34 1.635-1.731.591-.39 1.343-.582 2.256-.577a3.634 3.634 0 012.401.882c.687.583 1.028 1.373 1.024 2.371a3.179 3.179 0 01-.426 1.564C2.001-1.146 1.486-.512.736.26l-1.917 1.973 4.174.022-.011 2.116-7.455-.038.01-1.756 3.117-3.16C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(105.685 163.949)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-6.69l.01-2.012 6.473.033-.008 1.635-2.176 2.453c.846.144 1.5.504 1.962 1.076.459.573.689 1.231.685 1.978C6.94-.419 6.559.449 5.806 1.076c-.756.627-1.718.936-2.887.929C1.75 1.999.568 1.58-.629.747l.978-1.87c.994.711 1.885 1.069 2.672 1.074.473.002.865-.113 1.174-.343.307-.231.463-.564.466-1.003a1.222 1.222 0 00-.525-1.046c-.35-.259-.84-.39-1.464-.393-.332-.002-.803.09-1.409.279l.009-1.739 2.041-2.379L0-6.69z"
          transform="translate(140.976 166.618)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 1.428L.009-.418l2.269.012-.009 1.846 1.193.006-.01 2.042-1.194-.006-.013 2.525-2.269-.012.013-2.525-4.251-.022.01-1.801 3.799-6.226 2.571.014-3.616 5.985L0 1.428z"
          transform="translate(184.095 162.715)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.648l-.011 2.042-4.174-.022-.009 1.769a3.904 3.904 0 011.074-.129c1.02.005 1.894.316 2.628.934C.24-5.433.603-4.603.598-3.56.592-2.516.208-1.656-.556-.979-1.323-.303-2.263.033-3.382.027-4.814.019-6.005-.517-6.958-1.579l1.248-1.719c.09.091.212.203.362.336.151.131.427.306.829.526a2.53 2.53 0 001.208.33c.403.002.761-.116 1.075-.355.316-.242.473-.599.476-1.073.002-.472-.166-.839-.503-1.098-.336-.261-.77-.391-1.306-.394-.534-.003-1.155.186-1.863.565l-.976-1.062.027-5.158L0-10.648z"
          transform="translate(226.49 169.006)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 .739c-.469-.002-.862.136-1.183.411-.319.275-.479.636-.481 1.078a1.6 1.6 0 00.449 1.145c.3.318.677.48 1.131.482.453.003.831-.137 1.137-.417.304-.281.456-.646.459-1.095.002-.448-.133-.828-.404-1.136C.839.898.469.741 0 .739M.33-3.07c-.656-.004-1.163.213-1.523.65-.361.437-.583 1.033-.668 1.79.659-.422 1.355-.63 2.09-.626.989.005 1.811.333 2.468.981.657.65.983 1.509.977 2.584-.006 1.074-.364 1.931-1.079 2.572-.715.643-1.612.961-2.689.955-.747-.004-1.394-.15-1.942-.441a3.131 3.131 0 01-1.271-1.208c-.599-1.002-.895-2.254-.887-3.756.005-.968.126-1.816.367-2.546.24-.73.569-1.305.984-1.728.812-.842 1.812-1.26 3.001-1.253.494.002.965.078 1.414.226.447.149.791.299 1.033.45.241.154.506.347.798.579L2.275-2.182a5.06 5.06 0 00-.262-.245c-.117-.099-.345-.233-.686-.397A2.366 2.366 0 00.33-3.07"
          transform="translate(263.407 163.405)"
        ></path>
        <path
          fill="#FF8D72"
          fillRule="nonzero"
          d="M0-3.815l.018-3.387 7.636.039-.009 1.785-4.327 8.765-2.569-.014 4.128-8.524-2.662-.014-.007 1.362L0-3.815z"
          transform="translate(298.477 165.933)"
        ></path>
        <path
          fill="#777273"
          fillRule="nonzero"
          d="M0-2.961c.287.243.621.365 1.004.367a1.52 1.52 0 001.008-.356c.289-.242.433-.54.435-.898a1.142 1.142 0 00-.418-.903 1.513 1.513 0 00-1.012-.367 1.502 1.502 0 00-1.014.357 1.143 1.143 0 00-.43.899c-.001.358.141.656.427.901m-.167 4.62c.351.239.734.358 1.147.36a2.02 2.02 0 001.152-.348c.353-.236.533-.58.535-1.035.002-.452-.168-.801-.508-1.046A1.979 1.979 0 00.995-.777a1.974 1.974 0 00-1.166.355c-.344.241-.517.588-.52 1.041-.002.455.172.801.524 1.04m-1.434-7.788c.703-.552 1.58-.824 2.627-.819 1.05.006 1.92.287 2.613.845.693.558 1.037 1.243 1.033 2.054-.005.812-.32 1.508-.948 2.09.874.68 1.308 1.57 1.302 2.669-.005.927-.382 1.707-1.132 2.338-.748.632-1.725.944-2.924.937-1.2-.006-2.171-.327-2.914-.967-.743-.639-1.112-1.423-1.107-2.35.006-1.099.449-1.984 1.33-2.655-.631-.599-.946-1.3-.942-2.106.005-.806.358-1.487 1.062-2.036"
          transform="translate(64.665 189.438)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-.743c.468.002.86-.13 1.174-.401.314-.271.472-.628.474-1.071a1.624 1.624 0 00-.447-1.153 1.499 1.499 0 00-1.132-.49c-.454-.002-.825.14-1.115.426-.288.287-.434.651-.436 1.094-.002.445.126.821.388 1.129.261.31.625.464 1.094.466m-.346 3.811c.656.003 1.163-.213 1.523-.65.361-.437.583-1.033.668-1.789a3.662 3.662 0 01-2.091.639C-1.234 1.262-2.057.934-2.713.28c-.657-.653-.982-1.514-.977-2.584.005-1.069.366-1.927 1.079-2.573C-1.896-5.524-1-5.843.08-5.838c.745.004 1.392.15 1.94.441.548.289.977.693 1.287 1.209.589 1.001.881 2.253.874 3.755-.006.968-.128 1.816-.369 2.546-.242.73-.564 1.306-.97 1.727-.83.843-1.837 1.26-3.017 1.254a4.604 4.604 0 01-1.42-.227c-.453-.148-.794-.296-1.025-.443a10.268 10.268 0 01-.799-.572l1.188-1.656c.069.06.163.139.278.235.116.097.34.227.672.389.331.164.642.246.935.248"
          transform="translate(104.762 188.531)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.226 0 1.958-.011l.044-8.561-2.012-.01.01-2.012z"
          transform="translate(135.881 193.688)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-5.111c-.337.642-.507 1.493-.513 2.553C-.519-1.501-.357-.646-.026 0c.329.648.847.972 1.552.976C2.232.98 2.753.66 3.089.016c.337-.643.507-1.496.513-2.553.005-1.059-.156-1.912-.487-2.558-.329-.648-.847-.973-1.553-.976-.705-.004-1.226.315-1.562.96m1.516 8.022c-1.462-.008-2.553-.509-3.275-1.507-.72-.996-1.075-2.324-1.066-3.982.008-1.658.377-2.983 1.108-3.973.732-.989 1.827-1.478 3.29-1.471 1.462.008 2.552.509 3.275 1.505.72.998 1.077 2.326 1.069 3.984-.009 1.658-.38 2.983-1.11 3.971-.733.99-1.828 1.48-3.291 1.473"
          transform="translate(145.154 190.932)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.226 0 1.957-.011l.044-8.561-2.012-.01L0-10.594z"
          transform="translate(178.274 193.611)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.226 0 1.957-.011l.044-8.56-2.011-.011.01-2.012z"
          transform="translate(184.369 193.642)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.226 0 1.957-.012l.044-8.56-2.011-.01.01-2.012z"
          transform="translate(214.699 194.096)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-2.097c.269-.376.405-.741.407-1.093a1.218 1.218 0 00-.344-.887c-.231-.238-.527-.358-.891-.36-.666-.003-1.299.467-1.897 1.411L-4.61-4.154c.498-.765 1.042-1.341 1.635-1.731.591-.391 1.344-.582 2.257-.577a3.62 3.62 0 012.4.882c.687.582 1.029 1.373 1.024 2.371a3.178 3.178 0 01-.426 1.563C2.001-1.148 1.486-.514.737.259l-1.918 1.972 4.175.022-.012 2.117-7.454-.039.009-1.755 3.117-3.16C-.718-1.215-.269-1.719 0-2.097"
          transform="translate(225.621 189.777)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.594l4.28.022L4.226 0 1.957-.011l.044-8.561-2.012-.01L0-10.594z"
          transform="translate(254.161 194.301)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-6.69l.01-2.012 6.472.033-.008 1.635-2.175 2.453c.846.145 1.5.504 1.962 1.076.459.573.688 1.231.684 1.978C6.939-.419 6.558.45 5.806 1.076c-.756.627-1.719.936-2.887.93C1.749 1.999.567 1.581-.63.748l.978-1.87c.995.71 1.886 1.069 2.673 1.073.472.002.864-.112 1.173-.342.308-.232.464-.565.466-1.003a1.223 1.223 0 00-.524-1.047c-.351-.258-.84-.39-1.464-.393-.332-.002-.803.091-1.409.279l.009-1.739 2.04-2.379L0-6.69z"
          transform="translate(260.912 192.443)"
        ></path>
        <path
          fill="#FF8D72"
          fillRule="nonzero"
          d="M0-10.594l4.28.022L4.226 0l-2.27-.011.045-8.56-2.012-.011L0-10.594z"
          transform="translate(293.644 194.505)"
        ></path>
        <path
          fill="#FF8D72"
          fillRule="nonzero"
          d="M0 1.427L.01-.419l2.268.012-.009 1.846 1.194.006-.011 2.042-1.193-.007-.014 2.527-2.268-.013.012-2.525-4.251-.022.01-1.801L-.453-4.58l2.571.013-3.616 5.986L0 1.427z"
          transform="translate(304.033 188.542)"
        ></path>
        <path
          fill="#777273"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.226 0 1.957-.012l.044-8.56-2.012-.01L0-10.594z"
          transform="translate(56.954 219.274)"
        ></path>
        <path
          fill="#777273"
          fillRule="nonzero"
          d="M0-10.648l-.011 2.042-4.174-.022-.009 1.769a3.904 3.904 0 011.074-.129c1.019.005 1.893.316 2.628.934C.24-5.433.603-4.603.598-3.56.592-2.516.208-1.656-.556-.979-1.323-.302-2.263.033-3.382.027-4.814.019-6.005-.517-6.958-1.579l1.248-1.719c.09.092.212.203.361.336.152.131.428.307.829.526.403.218.806.329 1.209.33.403.002.761-.116 1.075-.355.315-.242.473-.599.476-1.073.002-.472-.166-.839-.503-1.098-.337-.26-.77-.391-1.306-.394-.534-.003-1.155.186-1.863.565l-.977-1.062.027-5.158L0-10.648z"
          transform="translate(70.233 219.397)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.593l4.281.022L4.226 0 1.957-.011l.044-8.56-2.012-.01L0-10.593z"
          transform="translate(96.507 219.478)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 .739c-.468-.002-.862.136-1.182.411-.319.275-.479.636-.482 1.078-.002.446.148.825.449 1.145.301.318.677.48 1.132.482.452.003.831-.137 1.136-.417.304-.281.456-.645.459-1.094.002-.449-.133-.829-.404-1.137C.839.898.469.741 0 .739M.33-3.07c-.656-.003-1.163.214-1.523.651-.36.436-.583 1.033-.667 1.789.658-.422 1.355-.63 2.09-.626.988.005 1.811.333 2.467.981.657.65.983 1.51.977 2.585-.006 1.073-.363 1.931-1.079 2.571-.715.643-1.612.961-2.688.955-.747-.004-1.395-.15-1.943-.441a3.131 3.131 0 01-1.271-1.208c-.599-1.001-.895-2.254-.887-3.756.005-.968.126-1.816.367-2.546.241-.729.57-1.305.985-1.728.811-.842 1.811-1.26 3.001-1.253a4.55 4.55 0 011.414.226c.446.149.791.299 1.033.45.241.154.506.347.798.579L2.276-2.182a6.242 6.242 0 00-.263-.245c-.116-.099-.345-.232-.686-.397A2.363 2.363 0 00.33-3.07"
          transform="translate(107.148 213.796)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.227 0 1.958-.012l.044-8.56-2.012-.01.01-2.012z"
          transform="translate(135.896 219.683)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-3.813l.018-3.388 7.636.04-.009 1.785-4.327 8.764-2.569-.013 4.127-8.524-2.662-.015-.006 1.362L0-3.813z"
          transform="translate(142.217 216.322)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.226 0 1.957-.012l.044-8.56-2.011-.01.01-2.012z"
          transform="translate(175.509 219.888)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-2.961a1.52 1.52 0 001.004.367c.384.002.721-.117 1.008-.357.29-.241.434-.538.436-.896a1.144 1.144 0 00-.419-.904 1.517 1.517 0 00-1.012-.367 1.504 1.504 0 00-1.014.357 1.145 1.145 0 00-.429.899c-.002.358.141.657.426.901m-.166 4.62c.35.239.733.358 1.146.36.414.002.797-.113 1.152-.348.353-.235.534-.58.535-1.035C2.67.184 2.5-.165 2.159-.41A1.986 1.986 0 00.995-.778a1.982 1.982 0 00-1.166.356C-.514-.181-.688.166-.69.619c-.003.455.171.801.524 1.04M-1.6-6.129c.702-.552 1.579-.824 2.627-.819 1.049.006 1.919.287 2.612.846.693.557 1.037 1.242 1.033 2.053-.004.812-.32 1.508-.947 2.09.874.68 1.308 1.57 1.302 2.668-.005.928-.382 1.708-1.133 2.339-.748.633-1.724.944-2.924.938-1.199-.007-2.17-.328-2.914-.968-.742-.639-1.111-1.423-1.106-2.35.006-1.099.449-1.984 1.33-2.655-.632-.599-.947-1.3-.942-2.106.004-.806.357-1.487 1.062-2.036"
          transform="translate(184.964 216.055)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.226 0 1.957-.012l.044-8.56-2.012-.01L0-10.594z"
          transform="translate(214.971 220.092)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-.743c.469.002.86-.13 1.174-.401.314-.271.472-.628.474-1.071a1.627 1.627 0 00-.446-1.153A1.496 1.496 0 00.07-3.857c-.455-.003-.825.139-1.115.425-.288.287-.434.651-.436 1.094-.003.445.126.822.387 1.129.261.31.626.464 1.094.466m-.345 3.811c.656.003 1.163-.214 1.523-.65.36-.437.582-1.033.667-1.79a3.651 3.651 0 01-2.091.64c-.987-.005-1.81-.334-2.467-.987-.657-.654-.982-1.516-.976-2.585.005-1.069.365-1.927 1.078-2.573.715-.647 1.612-.967 2.691-.961.745.004 1.393.15 1.941.441.547.29.977.693 1.286 1.208.589 1.002.881 2.254.874 3.757-.005.968-.128 1.815-.369 2.545s-.564 1.305-.97 1.726c-.83.844-1.836 1.262-3.016 1.255a4.593 4.593 0 01-1.42-.226c-.454-.149-.795-.297-1.026-.444a10.42 10.42 0 01-.799-.571l1.189-1.657c.068.06.163.14.277.235.116.097.341.227.672.389.331.164.643.246.936.248"
          transform="translate(225.057 215.147)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-2.095c.27-.376.405-.741.407-1.093a1.212 1.212 0 00-.344-.887c-.231-.239-.527-.359-.89-.361-.666-.003-1.3.468-1.898 1.412L-4.61-4.153c.499-.764 1.043-1.34 1.635-1.731.591-.39 1.344-.582 2.256-.577a3.636 3.636 0 012.402.882c.686.583 1.028 1.373 1.023 2.371a3.177 3.177 0 01-.425 1.564C2.001-1.146 1.486-.512.737.26l-1.918 1.973 4.175.022-.011 2.116-7.455-.038.009-1.756 3.117-3.159C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(259.783 215.946)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-5.112c-.337.643-.508 1.494-.513 2.553-.006 1.057.157 1.912.487 2.558.329.648.847.973 1.552.976.705.004 1.227-.315 1.563-.96.337-.643.508-1.495.513-2.552.005-1.06-.156-1.913-.487-2.559-.329-.648-.846-.973-1.553-.976-.705-.004-1.226.315-1.562.96M1.517 2.91c-1.463-.007-2.554-.509-3.276-1.507-.72-.996-1.075-2.324-1.066-3.982.009-1.658.377-2.982 1.107-3.972C-.985-7.54.11-8.03 1.573-8.023c1.462.008 2.553.51 3.275 1.505.72.998 1.077 2.326 1.068 3.984C5.907-.875 5.537.449 4.807 1.437c-.733.991-1.828 1.481-3.29 1.473"
          transform="translate(267.285 217.559)"
        ></path>
        <path
          fill="#FF8D72"
          fillRule="nonzero"
          d="M0-2.095c.27-.376.405-.741.407-1.093a1.216 1.216 0 00-.343-.887c-.232-.239-.528-.359-.891-.361-.666-.003-1.299.468-1.898 1.412l-1.884-1.129c.498-.764 1.042-1.34 1.635-1.731.591-.39 1.343-.582 2.256-.577a3.634 3.634 0 012.401.882c.686.583 1.028 1.373 1.023 2.371a3.182 3.182 0 01-.425 1.563C2.002-1.146 1.486-.512.737.26L-1.18 2.233l4.174.022-.012 2.116-7.454-.038.009-1.756 3.117-3.16C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(298.727 216.148)"
        ></path>
        <path
          fill="#FF8D72"
          fillRule="nonzero"
          d="M0-10.594l4.281.022L4.227 0l-2.27-.012.045-8.56-2.013-.01L0-10.594z"
          transform="translate(303.052 220.548)"
        ></path>
        <path
          fill="#777273"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.216 1.216 0 00-.343-.887c-.232-.239-.528-.359-.892-.361-.666-.003-1.298.468-1.897 1.411L-4.61-4.153c.498-.764 1.043-1.34 1.636-1.731.591-.39 1.343-.582 2.256-.577a3.628 3.628 0 012.401.882c.686.583 1.028 1.373 1.023 2.371a3.188 3.188 0 01-.425 1.564C2.001-1.146 1.486-.512.737.26L-1.18 2.233l4.174.022-.011 2.116-7.455-.038.009-1.756 3.117-3.159C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(61.083 240.305)"
        ></path>
        <path
          fill="#777273"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.22 1.22 0 00-.343-.887c-.232-.239-.528-.359-.892-.361-.666-.003-1.298.468-1.897 1.412L-4.61-4.153c.498-.764 1.042-1.34 1.635-1.731.591-.39 1.344-.582 2.257-.577a3.631 3.631 0 012.4.882c.687.583 1.029 1.373 1.024 2.371a3.172 3.172 0 01-.426 1.563C2.001-1.146 1.486-.512.737.26L-1.18 2.233l4.174.022-.012 2.116-7.454-.038.009-1.756 3.117-3.159C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(70.233 240.353)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.212 1.212 0 00-.344-.887c-.231-.239-.527-.359-.891-.361-.666-.003-1.299.468-1.897 1.411L-4.61-4.153c.498-.764 1.042-1.34 1.635-1.731.591-.39 1.344-.582 2.256-.577a3.627 3.627 0 012.401.882c.687.583 1.028 1.373 1.024 2.371a3.172 3.172 0 01-.426 1.563C2.001-1.146 1.486-.512.737.26l-1.918 1.973 4.175.022-.012 2.116-7.454-.038.009-1.756 3.117-3.159C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(101.508 240.336)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-6.689l.01-2.012 6.473.033-.008 1.635L4.299-4.58c.846.145 1.5.504 1.962 1.076.459.573.689 1.231.685 1.978C6.94-.418 6.559.45 5.806 1.077c-.756.626-1.718.935-2.887.929C1.75 2 .568 1.581-.629.749l.978-1.871c.994.711 1.885 1.069 2.672 1.073.473.003.865-.112 1.174-.341.307-.232.463-.566.466-1.004a1.22 1.22 0 00-.525-1.046c-.35-.259-.84-.39-1.464-.394-.332-.001-.803.091-1.409.28l.009-1.739 2.041-2.379L0-6.689z"
          transform="translate(106.487 242.847)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.218 1.218 0 00-.344-.887c-.231-.238-.527-.359-.891-.36-.666-.004-1.299.467-1.897 1.411L-4.61-4.153c.498-.764 1.043-1.34 1.635-1.73.591-.391 1.343-.583 2.256-.578a3.628 3.628 0 012.401.883c.687.582 1.028 1.373 1.024 2.371a3.178 3.178 0 01-.426 1.563C2.001-1.146 1.486-.512.737.26l-1.918 1.973 4.175.022-.011 2.116-7.455-.038.009-1.755 3.117-3.16C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(140.992 240.54)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 1.428L.01-.418l2.268.012-.009 1.846 1.193.006-.01 2.042-1.194-.007-.013 2.526-2.268-.012.013-2.525-4.252-.022.01-1.801 3.799-6.226 2.571.013-3.616 5.986L0 1.428z"
          transform="translate(149.611 238.946)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.216 1.216 0 00-.344-.887c-.231-.239-.527-.359-.891-.361-.666-.003-1.299.468-1.897 1.412L-4.61-4.153c.498-.764 1.042-1.34 1.635-1.73.591-.391 1.343-.583 2.256-.578a3.634 3.634 0 012.401.882c.687.583 1.028 1.373 1.024 2.372a3.187 3.187 0 01-.425 1.563C2.001-1.146 1.486-.512.736.26l-1.917 1.973 4.174.022-.011 2.116-7.455-.038.01-1.755 3.117-3.16C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(180.498 240.745)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-10.648l-.01 2.042-4.175-.022-.009 1.769a3.943 3.943 0 011.074-.129c1.02.006 1.894.316 2.628.935.732.62 1.095 1.45 1.09 2.494C.592-2.516.208-1.656-.556-.978-1.322-.302-2.263.033-3.381.027-4.814.019-6.005-.516-6.958-1.579l1.248-1.718c.09.091.212.202.362.336.151.131.427.306.829.525.402.218.805.329 1.208.331.403.002.761-.117 1.075-.356.315-.242.473-.599.476-1.073.002-.472-.166-.839-.503-1.097-.336-.261-.77-.392-1.306-.394-.534-.003-1.155.185-1.863.565l-.976-1.063.026-5.158L0-10.648z"
          transform="translate(192.005 245.236)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.218 1.218 0 00-.344-.887c-.231-.239-.527-.359-.891-.36-.666-.004-1.299.467-1.897 1.411L-4.61-4.153c.498-.764 1.042-1.34 1.635-1.73.591-.391 1.343-.583 2.256-.578a3.63 3.63 0 012.401.883c.687.582 1.029 1.373 1.024 2.371a3.178 3.178 0 01-.426 1.563C2.001-1.146 1.486-.512.737.26l-1.918 1.973 4.174.022-.011 2.116-7.455-.038.01-1.755 3.117-3.16C-.718-1.213-.269-1.717 0-2.095"
          transform="translate(220.051 240.949)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 .738c-.468-.002-.863.136-1.182.412-.32.274-.48.635-.482 1.078-.003.445.148.825.449 1.145.3.317.677.48 1.132.482.452.002.831-.138 1.136-.417.304-.282.456-.646.458-1.095.003-.449-.132-.829-.403-1.136C.839.897.468.74 0 .738m.33-3.809c-.656-.003-1.163.214-1.523.651-.36.436-.583 1.033-.668 1.789.658-.422 1.356-.63 2.09-.626.989.006 1.812.334 2.468.981.657.65.983 1.51.977 2.585-.006 1.073-.364 1.931-1.079 2.572-.715.642-1.612.96-2.689.954-.746-.004-1.394-.149-1.942-.441a3.125 3.125 0 01-1.271-1.208c-.599-1.001-.895-2.254-.887-3.756.005-.968.126-1.816.366-2.546.242-.729.571-1.305.986-1.728.81-.842 1.811-1.259 3.001-1.253.493.002.964.078 1.414.226.446.149.791.299 1.032.45.241.154.507.347.798.58L2.276-2.183a7.893 7.893 0 00-.263-.245c-.117-.099-.346-.232-.686-.396a2.364 2.364 0 00-.997-.247"
          transform="translate(228.921 239.637)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.216 1.216 0 00-.343-.887c-.232-.239-.528-.359-.891-.361-.667-.003-1.299.468-1.898 1.412L-4.61-4.153c.499-.764 1.043-1.34 1.635-1.731.591-.39 1.343-.582 2.257-.577a3.634 3.634 0 012.401.882c.686.583 1.028 1.373 1.023 2.371a3.179 3.179 0 01-.426 1.564C2.001-1.146 1.486-.512.737.26L-1.18 2.233l4.174.022-.012 2.116-7.454-.038.009-1.756 3.117-3.159C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(259.443 241.154)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-3.813l.018-3.388 7.636.04-.008 1.785-4.328 8.764-2.569-.013 4.128-8.524-2.662-.014-.008 1.361L0-3.813z"
          transform="translate(263.993 242.162)"
        ></path>
        <path
          fill="#FF8D72"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.212 1.212 0 00-.344-.887c-.231-.239-.527-.359-.89-.361-.666-.003-1.3.468-1.898 1.411L-4.61-4.153c.498-.764 1.043-1.34 1.635-1.731.592-.39 1.343-.582 2.256-.577a3.631 3.631 0 012.402.882c.686.583 1.028 1.373 1.023 2.371a3.17 3.17 0 01-.425 1.563C2.001-1.146 1.486-.512.737.26l-1.918 1.973 4.175.022-.012 2.116-7.454-.038.009-1.756 3.117-3.159C-.718-1.214-.269-1.717 0-2.095"
          transform="translate(299.052 241.359)"
        ></path>
        <path
          fill="#FF8D72"
          fillRule="nonzero"
          d="M0-2.959c.287.242.62.365 1.004.367a1.52 1.52 0 001.008-.356c.29-.242.433-.54.435-.898a1.138 1.138 0 00-.418-.903 1.508 1.508 0 00-1.012-.367 1.506 1.506 0 00-1.014.356 1.15 1.15 0 00-.43.9c-.002.358.142.656.427.901m-.166 4.62c.35.239.733.358 1.146.36.414.002.797-.113 1.152-.348.353-.236.533-.581.535-1.035C2.67.186 2.5-.163 2.159-.408A1.987 1.987 0 00.994-.776 1.979 1.979 0 00-.172-.42C-.515-.179-.688.168-.69.621c-.002.454.171.801.524 1.04m-1.435-7.788c.703-.552 1.58-.825 2.627-.819 1.05.005 1.92.286 2.613.845.693.558 1.037 1.243 1.033 2.054-.004.812-.32 1.508-.947 2.089.874.681 1.307 1.571 1.301 2.67-.004.927-.381 1.707-1.132 2.338-.748.632-1.724.943-2.924.937-1.199-.006-2.17-.327-2.914-.967-.743-.639-1.112-1.423-1.107-2.35.006-1.099.449-1.984 1.33-2.656-.632-.598-.946-1.299-.941-2.105.004-.806.357-1.487 1.061-2.036"
          transform="translate(306.736 241.893)"
        ></path>
        <path
          fill="#777273"
          fillRule="nonzero"
          d="M0-2.095c.269-.376.405-.741.407-1.093a1.212 1.212 0 00-.344-.887c-.231-.239-.527-.359-.891-.361-.666-.003-1.299.468-1.897 1.411L-4.61-4.153c.498-.764 1.042-1.34 1.635-1.731.591-.39 1.344-.582 2.257-.577a3.625 3.625 0 012.4.883c.687.582 1.029 1.372 1.024 2.37a3.172 3.172 0 01-.426 1.563C2.001-1.146 1.486-.512.737.26l-1.918 1.973 4.175.022-.011 2.116-7.455-.038.009-1.755 3.117-3.16C-.718-1.213-.269-1.717 0-2.095"
          transform="translate(60.33 265.357)"
        ></path>
        <path
          fill="#777273"
          fillRule="nonzero"
          d="M0-.743c.469.002.861-.13 1.174-.401.314-.272.472-.628.474-1.071a1.623 1.623 0 00-.446-1.153A1.496 1.496 0 00.07-3.857c-.455-.003-.825.139-1.115.425-.288.287-.434.651-.436 1.094-.003.445.126.821.387 1.128.261.31.626.464 1.094.467m-.345 3.811c.656.002 1.163-.214 1.523-.651.36-.436.582-1.033.667-1.789a3.659 3.659 0 01-2.091.64c-.987-.005-1.81-.334-2.466-.988-.658-.654-.983-1.515-.977-2.585.005-1.068.365-1.926 1.078-2.573.715-.646 1.612-.966 2.691-.96.745.003 1.393.15 1.941.441.547.29.977.693 1.286 1.208.589 1.002.881 2.254.874 3.756-.005.968-.128 1.816-.369 2.545-.241.73-.564 1.306-.97 1.727-.83.844-1.836 1.262-3.016 1.255a4.565 4.565 0 01-1.42-.227c-.454-.148-.795-.297-1.026-.444a10.15 10.15 0 01-.799-.571l1.189-1.657c.068.06.163.14.277.236.116.097.341.226.672.389.331.164.643.246.936.248"
          transform="translate(68.644 264.781)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-6.689l.01-2.012 6.473.033-.008 1.635L4.299-4.58c.846.145 1.5.504 1.962 1.076.459.574.689 1.231.685 1.977C6.94-.418 6.559.45 5.806 1.077c-.756.627-1.718.935-2.887.929C1.75 2 .568 1.582-.629.748l.978-1.87c.994.711 1.885 1.07 2.672 1.074.473.003.865-.113 1.174-.342.307-.232.463-.565.466-1.004a1.222 1.222 0 00-.525-1.046c-.35-.259-.84-.39-1.464-.393-.332-.002-.803.09-1.409.28l.009-1.74 2.041-2.379L0-6.689z"
          transform="translate(95.733 268.025)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0-5.11c-.337.643-.508 1.493-.513 2.553C-.519-1.5-.357-.645-.026 0 .302.649.82.974 1.526.977c.705.004 1.227-.316 1.562-.96.338-.643.508-1.496.514-2.554.005-1.058-.156-1.911-.487-2.557-.329-.649-.847-.973-1.553-.977C.857-6.075.335-5.755 0-5.11m1.516 8.022c-1.462-.007-2.553-.509-3.275-1.507-.72-.996-1.075-2.324-1.067-3.982.009-1.659.378-2.982 1.108-3.973.733-.989 1.828-1.479 3.291-1.471 1.462.008 2.552.509 3.275 1.505.719.998 1.077 2.326 1.068 3.984-.008 1.658-.379 2.983-1.11 3.971-.732.99-1.827 1.48-3.29 1.473"
          transform="translate(107.192 267.172)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47a4.471 4.471 0 10-.002 8.938A4.471 4.471 0 00-4.47-4.47"
          transform="matrix(0 -1 -1 0 74.633 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.458a1.98 1.98 0 01-1.98-1.979L-2.442 1.98A1.979 1.979 0 01-.463 0h.457a1.98 1.98 0 011.981 1.979l.004 18.135A1.98 1.98 0 010 22.094"
          transform="translate(74.865 66.056)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47a4.47 4.47 0 100 8.94 4.47 4.47 0 100-8.94"
          transform="matrix(0 -1 -1 0 107.282 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.458a1.98 1.98 0 01-1.98-1.979L-2.443 1.98A1.98 1.98 0 01-.463 0h.457a1.98 1.98 0 011.98 1.979l.005 18.135A1.98 1.98 0 010 22.094"
          transform="translate(107.514 66.056)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47a4.47 4.47 0 100 8.94 4.47 4.47 0 100-8.94"
          transform="matrix(0 -1 -1 0 139.932 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.458a1.98 1.98 0 01-1.98-1.979L-2.442 1.98A1.979 1.979 0 01-.463 0h.458a1.98 1.98 0 011.98 1.979l.004 18.135A1.98 1.98 0 010 22.094"
          transform="translate(140.163 66.056)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47a4.471 4.471 0 10-.002 8.938A4.471 4.471 0 00-4.47-4.47"
          transform="matrix(0 -1 -1 0 172.581 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.458a1.98 1.98 0 01-1.98-1.979L-2.442 1.98A1.979 1.979 0 01-.463 0h.457c1.093 0 1.98.886 1.981 1.979l.004 18.135A1.98 1.98 0 010 22.094"
          transform="translate(172.812 66.056)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47a4.47 4.47 0 100 8.94 4.47 4.47 0 100-8.94"
          transform="matrix(0 -1 -1 0 205.23 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.458a1.98 1.98 0 01-1.98-1.979L-2.443 1.98A1.98 1.98 0 01-.464 0h.458a1.98 1.98 0 011.98 1.979l.005 18.135A1.98 1.98 0 010 22.094"
          transform="translate(205.462 66.056)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47A4.471 4.471 0 00-8.942 0 4.471 4.471 0 00.001 0 4.47 4.47 0 00-4.47-4.47"
          transform="matrix(0 -1 -1 0 237.879 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.458a1.98 1.98 0 01-1.98-1.979L-2.442 1.98A1.979 1.979 0 01-.463 0h.458a1.98 1.98 0 011.98 1.979l.004 18.135A1.98 1.98 0 010 22.094"
          transform="translate(238.111 66.056)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47a4.471 4.471 0 10-.002 8.938A4.471 4.471 0 00-4.47-4.47"
          transform="matrix(0 -1 -1 0 270.528 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.457a1.98 1.98 0 01-1.981-1.979L-2.442 1.98A1.98 1.98 0 01-.463 0h.458a1.98 1.98 0 011.98 1.979l.004 18.135A1.98 1.98 0 010 22.094"
          transform="translate(270.76 66.056)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47a4.471 4.471 0 10-.002 8.938A4.471 4.471 0 00-4.47-4.47"
          transform="matrix(0 -1 -1 0 303.178 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.458a1.98 1.98 0 01-1.98-1.979L-2.442 1.98A1.98 1.98 0 01-.463 0h.457a1.98 1.98 0 011.981 1.979l.004 18.135A1.98 1.98 0 010 22.094"
          transform="translate(303.409 66.056)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47a4.47 4.47 0 100 8.94 4.47 4.47 0 100-8.94"
          transform="matrix(0 -1 -1 0 335.827 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.458a1.98 1.98 0 01-1.98-1.979L-2.442 1.98C-2.442.887-1.557 0-.464 0h.458a1.98 1.98 0 011.981 1.979l.004 18.135A1.98 1.98 0 010 22.094"
          transform="translate(336.059 66.056)"
        ></path>
        <path
          fill="#FF8B73"
          fillRule="nonzero"
          d="M-4.47-4.47a4.47 4.47 0 10-.001 8.941A4.47 4.47 0 00-4.47-4.47"
          transform="matrix(0 -1 -1 0 368.476 81.846)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M0 22.094h-.458a1.98 1.98 0 01-1.98-1.979L-2.442 1.98A1.978 1.978 0 01-.464 0h.458a1.98 1.98 0 011.981 1.979l.004 18.135A1.98 1.98 0 010 22.094"
          transform="translate(368.708 66.056)"
        ></path>
        <g transform="translate(-34.232)">
          <clipPath id="_clip2">
            <path
              d="M313.441 50.385c-24.66 8.303-79.224 24.868-105.761 26.875-48.797 3.69-80.473-11.68-108.515-12.091-49.904-.727-92.886 67.016-66.045 111.768 8.715 14.532 14.571 31.719 25.79 44.418 23.75 26.883 9.258 65.103.179 100.049-5.683 21.877-18.61 45.327-6.028 78.292 3.092 8.1 12.816 13.635 15.665 21.234 10.308 27.502 36.474 46.628 69.112 47.382 43.898 1.013 81.28-25.782 120.449-41.496 19.393-7.779 39.662-13.203 60.722-11.343 25.17 2.222 47.821 15.039 73.434 16.375 32.387 1.688 65.825-14.687 77.613-46.239 10.678-28.585-2.637-55.206-16.1-80.095-5.157-9.53-9.701-18.4-13.19-27.213-7.049-17.812-9.786-35.398-4.527-57.752 4.278-18.179 10.959-35.958 12.179-54.593C454.002 80.593 414.931 42 360.57 41.997c-14.778-.001-30.679 2.85-47.129 8.388z"
              clipRule="nonzero"
            ></path>
          </clipPath>
          <g clipPath="url(#_clip2)">
            <path
              fill="#FFC5C3"
              fillRule="nonzero"
              d="M-9.739-8.072c-2.736-5.76-25.754 17.753-17.717 20.051 8.037 2.298 17.717 11.103 17.717 11.103L4.72 7.314S-7.004-2.312-9.739-8.072"
              transform="scale(1 -1) rotate(47.478 365.442 97.52)"
            ></path>
            <path
              fill="#FFAEAB"
              fillRule="nonzero"
              d="M8.565-18.226c4.676 4.662 4.905 10.562 2.3 17.502a27.501 27.501 0 01-2.3 4.749C3.917-.631-2.24-5.194-2.24-5.194L8.565-18.226z"
              transform="scale(-1 1) rotate(50.339 -344.695 -85.728)"
            ></path>
            <path
              fill="#FFC5C3"
              fillRule="nonzero"
              d="M0-.849c-.126-1.203-1.103-6.25-1.696-9.266a56.146 56.146 0 00-.413-2.084l-.044-.218-.002.011C-4.979-25.182-11.217-29.585-20.2-29.585c-11.706 0-21.196 13.304-21.196 29.715s13.915 24.322 25.446 26.338c12.969 2.268 15.557.629 16.261-7.096l.004-.006c1.15-3.225.786-9.391 2.804-10.951C5.137 6.856.184.894 0-.849"
              transform="translate(199.12 210.101)"
            ></path>
            <path
              fill="#1E1E1E"
              fillRule="nonzero"
              d="M0-44.539c-1.015-3.292-4.528-1.436-7.113.508-.056-.238 7.57-4.896 5.262-6.511-3.62-2.534-7.34 2.3-7.584 2.094 2.229-2.381 1.691-2.672-.112-3.21-.682-.204-2.963-.024-5.54 1.425-2.387 1.342-5.058 2.109-7.793 1.986-2.608-.118-6.282-.395-13.015-.709-15.451-.718-17.368 13.775-17.368 13.775s-6.347 4.791-5.509 14.852c.838 10.061 18.685 25.632 18.685 25.632s7.666 3.234 15.57-3.713c7.906-6.947 3.833-11.738 7.27-15.465 3.436-3.727.037-5.256-.682-11.485-.718-6.228 7.733-7.853 7.733-7.853C-.698-39.786.543-42.777 0-44.539"
              transform="translate(206.343 227.755)"
            ></path>
            <path
              fill="#FFC5C3"
              fillRule="nonzero"
              d="M-4.202-6.873c-3.2 0-5.795 2.114-5.796 4.722 0 2.606 2.595 4.72 5.796 4.72 3.2-.001 5.795-2.114 5.795-4.722 0-2.607-2.595-4.721-5.795-4.72"
              transform="scale(-1 1) rotate(-62.889 82.918 254.342)"
            ></path>
            <path
              fill="#F0522C"
              fillRule="nonzero"
              d="M-66.627 69.061H-.001L9.316 0h-85.259l9.316 69.061z"
              transform="matrix(-1 0 0 1 143.146 396.858)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#BC3F20"
              strokeWidth="3.29"
              d="M0-51.486s.994 8.526 8.124 17.555L8.241 0"
              transform="translate(167.365 465.919)"
            ></path>
            <path
              fill="#FFC5C3"
              fillRule="nonzero"
              d="M-2.018-17.433s3.224 2.649 3.15 6.07c-.059 2.77-1.406 8.212-3.15 9.707-1.744 1.496-2.307.329-2.307.329l2.307-16.106z"
              transform="scale(-1 1) rotate(-4.373 2431.66 3412.043)"
            ></path>
            <path
              fill="#FFC5C3"
              fillRule="nonzero"
              d="M0 38.117s1.514-5.277 2.643-17.722c.165-1.809 1.052-5.435-.876-6.706-.415-.274-1.886-1.271-2.543.741.358-2.484-2.866-3.288-3.334-.841-.053-2.649-3.338-2.564-3.735-.287.122-3.081 0-4.416 0-7.705 0-3.289-.281-5.168-1.315-5.262-1.033-.094-2.264-.961-3.785 15.694-.348 3.797-.709 7.558-.581 9.967.224 4.23.8 7.142 2.416 8.237C-6.443 38.743 0 38.117 0 38.117"
              transform="translate(268.031 164.709)"
            ></path>
            <path
              fill="#FFAEAB"
              fillRule="nonzero"
              d="M.311.957h9.524c1.727-.149 3.2-1.4 3.807-3.232l1.666-3.982L.311.957z"
              transform="scale(1 -1) rotate(7.081 2943.261 772.734)"
            ></path>
            <path
              fill="#FFC5C3"
              fillRule="nonzero"
              d="M0-21.231s18.742 4.932 18.593 7.075C18.352-10.693 15.44-3.62 14.305-1.73c-.56.933-1.494 1.73-4.828 1.135C7.119-1.017 3.356-2.223.911-4.011c-4.436-3.244-5.267-6.813-5.267-6.813L0-21.231z"
              transform="translate(118.196 376.454)"
            ></path>
            <path
              fill="#FFAEAB"
              fillRule="nonzero"
              d="M-8.541-4.228c1.997.611 3.899 1.327 5.082 2.056 1.83 1.128-5.082 19.233-5.082 19.233l-2.3-.527c.535-6.866 1.132-13.909 2.3-20.762"
              transform="scale(1 -1) rotate(54.364 417.298 -45.685)"
            ></path>
            <path
              fill="#FFAEAB"
              fillRule="nonzero"
              d="M0 7.151c-.303 0-.61-.065-.902-.203l-5.555-2.622A2.115 2.115 0 11-4.649.499L.905 3.121A2.116 2.116 0 010 7.151"
              transform="translate(136.058 358.694)"
            ></path>
            <path
              fill="#FFC5C3"
              fillRule="nonzero"
              d="M0 7.15c-.302 0-.61-.065-.902-.203l-5.554-2.621A2.117 2.117 0 01-4.649.499L.905 3.121A2.114 2.114 0 010 7.15"
              transform="translate(134.609 362.632)"
            ></path>
            <path
              fill="#FFAEAB"
              fillRule="nonzero"
              d="M-4.073-2.696a2.118 2.118 0 01.956 2.113l-.956 6.068a2.111 2.111 0 01-1.745 1.749c.391-3.323.951-6.701 1.745-9.93"
              transform="scale(1 -1) rotate(55.78 411.19 -52.196)"
            ></path>
            <path
              fill="#FFC5C3"
              fillRule="nonzero"
              d="M0 7.151c-.303 0-.61-.065-.902-.203l-5.555-2.622A2.115 2.115 0 11-4.649.499L.905 3.121A2.116 2.116 0 010 7.151"
              transform="translate(133.161 366.57)"
            ></path>
            <path
              fill="#FFC5C3"
              fillRule="nonzero"
              d="M0 7.15a2.1 2.1 0 01-.901-.203l-5.555-2.621A2.116 2.116 0 11-4.649.499L.905 3.121A2.116 2.116 0 010 7.15"
              transform="translate(131.712 370.508)"
            ></path>
            <path
              fill="#004656"
              fillRule="nonzero"
              d="M16.055-24.734c-.305-.398-6.804 10.373-6.804 10.373s2.531 4.892 6.804 27.56l9.782 7.587s9.275-20.539-9.782-45.52"
              transform="scale(1 -1) rotate(-78.918 -53.08 -221.975)"
            ></path>
            <path
              fill="#00728A"
              fillRule="nonzero"
              d="M0-228.458l.147 4.96c-.503 12.835-10.608 43.754-10.608 43.754l-22.503 8.15c-18.969-3.068-31.676-1.942-31.676-1.942l-26.752-.495s-33.837 8.909-40.129 14.718c-6.292 5.809-50.518 55.059-50.76 61.835-.242 6.776 41.79 39.209 41.79 39.209l4.356-10.407s-6.29-16.832-18.37-30.318l29.111-17.562c1.448 18.232 1.549 25.518 2.897 42.681 2.318 29.517-1.438 57.416-1.438 57.416 49.654 16.459 96.33-1.087 96.33-1.087s-5.87-28.637-7.302-57.28c-1.432-28.642 8.925-55.775 8.925-55.775s35.606-27.106 36.443-35.897c.837-8.792 4.429-48.415 4.429-48.415l.75-8.67L0-228.458z"
              transform="translate(254.331 423.899)"
            ></path>
            <path
              fill="#004656"
              fillRule="nonzero"
              d="M0-50.05c-2.932 5.902-30.868 27.301-34.086 28.973-7.975 4.14-9.022 10.916-8.792 19.318.19 6.93 1.287 13.796 1.497 20.725.392 12.934.861 26.463 5.293 38.594a328.828 328.828 0 01-1.203-15.894c-1.432-28.643 8.925-55.776 8.925-55.776S7.24-41.215 8.077-50.006c.837-8.792 4.429-48.416 4.429-48.416l.75-8.67-1.663-.518C10.769-102.986 2.354-54.791 0-50.05"
              transform="translate(256.715 307.407)"
            ></path>
            <path
              fill="#004656"
              fillRule="nonzero"
              d="M0 118.763c-5.712-9.536-7.253-19.693-8.17-31.255-1.328-16.741-1.363-33.512-2.321-50.265-.415-7.254-.94-14.224-.614-21.496.234-5.246.555-10.605-.479-15.747-6.957 6.023-15.755 9.795-23.4 14.821-6.492 4.267-17.439 7.639-21.025 15.049-3.651 7.546 7.024 16.961 11.639 21.611 4.261 4.294 9.051 8.351 12.998 13.024l1.08-2.58s-6.291-16.832-18.371-30.317l29.112-17.563c1.448 18.233 1.549 25.519 2.897 42.681 2.318 29.517-1.438 57.416-1.438 57.416A135.164 135.164 0 000 118.763"
              transform="translate(148.488 293.298)"
            ></path>
            <path
              fill="#004656"
              fillRule="nonzero"
              d="M0-7.598s-36.797 5.873-55.995-11.599c0 0 14.904 30.796 55.995 11.599"
              transform="translate(200.323 395.261)"
            ></path>
            <path
              fill="#004656"
              fillRule="nonzero"
              d="M0-3.35C-2.375-1.53-5.215-.37-8.125.369a29.845 29.845 0 01-8.991.885c-3.01-.229-6.031-.698-8.844-1.791-1.44-.432-2.767-1.169-4.108-1.807-1.311-.712-2.548-1.565-3.743-2.43 1.467.341 2.823.861 4.231 1.218 1.414.335 2.776.779 4.19 1.018l2.09.428 2.106.301c.696.124 1.401.182 2.104.244.704.051 1.403.164 2.11.149l2.115.092c.705-.015 1.409-.047 2.117-.047 1.414-.034 2.823-.166 4.24-.311C-5.676-2.012-2.854-2.538 0-3.35"
              transform="translate(191.535 258.488)"
            ></path>
            <path
              fill="#00728A"
              fillRule="nonzero"
              d="M0-56.399c.082 3.098-4.735 3.495-4.817.38-.052-1.942-.069-3.91-.694-5.767-.991-2.948 3.551-4.595 4.542-1.647.77 2.287.906 4.642.969 7.034M10.947-8.972c-.505 1.212-2.061 1.689-3.212 1.164-1.4-.64-2.701-1.033-4.105-1.461-1.295-.395-2.138-1.391-1.941-2.812.166-1.191 1.599-2.311 2.812-1.941 1.78.542 3.585 1.062 5.282 1.838 1.228.56 1.664 2.013 1.164 3.212m14.599 3.135c.636-3.262 4.48-14.397 4.127-17.683a25.286 25.286 0 00-4.256-11.524c-8.301-12.2-12.156-10.03-14.827-18.66C-.038-88.053-18.531-73.695-34.42-88.035c0 0-2.265 20.422.371 23.819 1.955 2.52 4.796 4.096 7.899 4.837 1.556.37 2.839 1.243 3.618 2.865 1.567 3.26.393 5.58-1.955 7.293-3.644 2.659-5.449 7.224-4.248 11.573 2.692 9.742 9.446 14.98 18.313 15.327 11.835.463-9.691 53.975 43.738 39.043 0 0 16.295-13.337 2.79-34.075.03 1.951-11.156 14.575-10.56 11.516"
              transform="translate(94.839 449.541)"
            ></path>
            <path
              fill="#004656"
              fillRule="nonzero"
              d="M0 38.218c-.505 1.212-2.061 1.689-3.211 1.164-1.4-.64-2.702-1.033-4.105-1.461-1.296-.394-2.139-1.39-1.942-2.811.166-1.192 1.599-2.312 2.812-1.942 1.78.542 3.586 1.063 5.282 1.838C.064 35.567.5 37.019 0 38.218m-45.391-78.844c-.233 2.193-2.081 20.408.395 23.6 1.955 2.52 4.796 4.097 7.899 4.837 1.556.37 2.839 1.243 3.618 2.865 1.567 3.26.394 5.58-1.955 7.293-3.644 2.659-5.449 7.225-4.248 11.573 2.692 9.742 9.447 14.981 18.313 15.327 11.835.463-9.691 53.975 43.739 39.043 0 0-31.445-69.502-67.761-104.538"
              transform="translate(105.786 402.35)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.97"
              d="M-105.815 64.164c1.195-.16 82.19-13.43 144.722 0"
              transform="scale(-1 1) rotate(-62.463 243.733 323.187)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.97"
              d="M-20.612-1.264s12.565 2.345 20.665 0"
              transform="scale(-1 1) rotate(-2.696 8606.371 1814.326)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.97"
              d="M-8.37-4.818s5.866 1.919 11.143 0"
              transform="scale(-1 1) rotate(59.85 -418.986 114.065)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.97"
              d="M-.279-1.484s8.997-3.631 18.686 0"
              transform="scale(1 -1) rotate(-9.062 -2781.414 -886.391)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.97"
              d="M-9.422-7.956s6.676 3.05 15.622 0"
              transform="scale(-1 1) rotate(73.24 -374.33 137.06)"
            ></path>
            <path
              fill="#00728A"
              fillRule="nonzero"
              d="M0 39.642c-1.585 1.147-3.137 2.345-4.425 3.827-2.111 2.433-5.929-.796-3.816-3.229 1.558-1.795 3.449-3.301 5.368-4.691C-.258 33.656 2.603 37.757 0 39.642m-50.801-15.119c-2.552-4.935-4.323-10.103-4.547-15.69-.128-3.211 4.855-3.632 4.984-.415.206 5.162 1.903 9.828 4.258 14.38 1.479 2.86-3.238 4.542-4.695 1.725M-6.675-16.09a33.942 33.942 0 016.874-8.123c1.027-.888 2.767-.411 3.483.609.832 1.183.41 2.601-.61 3.483a26.436 26.436 0 00-5.235 6.187c-.704 1.157-2.013 1.81-3.334 1.178-1.132-.541-1.88-2.18-1.178-3.334m1.592 29.28c7.841-34.508 27.586-52.543 17.135-59.803C1.396-54.013-31.904-26.909-33.6-2.741c-.811 5.652.581 13.144-1.435 10.648-6.389-7.909-6.014-13.334-8.004-24.445-.463-2.584-2.227-4.848-4.739-5.61-2.75-.833-5.779.143-9.064 3.899-8.975 10.264-7.274 28.157-1.589 54.942-1.172-1.812-2.734-3.475-4.844-4.404-3.445-1.515-9.826-4.293-12.639-.261-2.463 3.531-.828 9.801-.169 13.626 2.239 12.993 13.138 20.34 21.957 29.094 2.117 2.103 4.115 4.287 5.844 6.648 3.141 4.292 4.699 11.397 11.01 11.915 4.193.344 8.501.005 12.66-.537 6.019-.784 10.83-3.919 12.031-10.177.511-2.657 15.362-11.904 18.842-13.872 24.035-13.59.364-25.279-14.907-11.612C3.378 36.492 10.857 32.022 16.69 25.211 50.166-3.052 25.201-20.506-5.083 13.19"
              transform="translate(367.165 376.18)"
            ></path>
            <path
              fill="#004656"
              fillRule="nonzero"
              d="M0 8.348C-2.552 3.413-4.323-1.755-4.547-7.341c-.128-3.211 4.855-3.633 4.983-.415C.643-2.594 2.34 2.071 4.694 6.623 6.174 9.483 1.457 11.165 0 8.348m62.063-71.577c-11.408-5.684-43.207 20.707-44.862 44.313-.811 5.652.581 13.144-1.435 10.648-6.389-7.908-6.014-13.334-8.004-24.445-.463-2.584-2.227-4.848-4.74-5.61-2.75-.833-5.778.143-9.063 3.9-8.976 10.263-7.274 28.156-1.589 54.941-1.172-1.811-2.734-3.475-4.845-4.403-3.444-1.516-9.825-4.294-12.638-.262-2.463 3.531-.828 9.801-.169 13.626 2.239 12.993 13.137 20.34 21.957 29.095 2.117 2.102 4.115 4.286 5.844 6.647 3.141 4.292 4.699 11.398 11.009 11.915.819.067 1.642.108 2.468.125-1.754-7.251 2.609-103.469 46.067-140.49"
              transform="translate(316.364 392.355)"
            ></path>
            <path
              fill="#fff"
              fillRule="nonzero"
              d="M0-124.409c-2.124 1.593-4.039 3.679-5.75 5.818l-1.293 1.619c-.432.539-.799 1.128-1.202 1.69l-1.183 1.704-.592.853-.538.888-2.143 3.56c-.717 1.185-1.303 2.447-1.961 3.667-.625 1.237-1.316 2.442-1.888 3.706l-1.705 3.798c-.548 1.274-1.18 2.513-1.66 3.817l-1.493 3.889-1.493 3.888-1.297 3.961-1.29 3.963c-.434 1.32-.872 2.638-1.212 3.987l-2.192 8.046-.547 2.01-.457 2.035-.913 4.07c-.589 2.717-1.255 5.418-1.784 8.147l-1.478 8.212c-.468 2.741-1.052 5.463-1.385 8.227l-1.153 8.265-.577 4.132-.288 2.067-.212 2.076L-39.384.293l-.003.024a.698.698 0 11-1.389-.142V.172l1.755-16.644.219-2.081.294-2.071.592-4.143 1.183-8.287c.342-2.769.937-5.5 1.415-8.249l1.509-8.234c.539-2.737 1.216-5.448 1.818-8.174l.929-4.082.464-2.041.557-2.019 2.227-8.076c.345-1.352.79-2.676 1.231-4.002l1.309-3.981 1.317-3.976 1.515-3.91 1.514-3.909c.488-1.309 1.128-2.557 1.685-3.84l1.729-3.821c.581-1.271 1.283-2.486 1.917-3.732.668-1.23 1.263-2.499 1.991-3.696l2.179-3.592.547-.898.603-.862 1.205-1.725c.41-.568.784-1.163 1.224-1.71l1.321-1.642c1.774-2.189 3.653-4.261 5.996-6.004a.487.487 0 11.582.781l-.051.039z"
              transform="translate(371.789 462.041)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.4"
              d="M-14.57-21.821s19.826 5.938 47.252 0"
              transform="scale(1 -1) rotate(-67.461 -116.537 -450.384)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.4"
              d="M-65.075-27.797s29.883-13.343 76.948 0"
              transform="scale(-1 1) rotate(46.259 -704.513 -201.377)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.4"
              d="M-41.475-9.613s17.946-7.037 43.703 0"
              transform="scale(-1 1) rotate(26.099 -1171.234 -499.466)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.4"
              d="M-10.782-21.045s19.467 7.031 51.858 0"
              transform="scale(1 -1) rotate(-54.256 -241.874 -523.89)"
            ></path>
            <path
              fill="#00728A"
              fillRule="nonzero"
              d="M0-67.656c.457 4.281 7.163 3.942 6.704-.362-.286-2.683-.625-5.398-.106-8.07.823-4.241-5.734-5.673-6.558-1.431-.639 3.291-.393 6.558-.04 9.863M-6.351-.336C-5.433 1.24-3.202 1.613-1.714.676.096-.462 1.815-1.243 3.67-2.091c1.711-.781 2.689-2.308 2.155-4.228-.447-1.609-2.626-2.889-4.228-2.155C-.755-7.4-3.145-6.352-5.338-4.972c-1.588.998-1.922 3.077-1.013 4.636m-19.526 7.003c-1.475-4.375-8.816-19.001-8.935-23.591-.149-5.777 1.152-11.483 3.741-16.65 9.186-18.327 14.894-16.047 16.984-28.423 8.316-49.254 36.423-32.884 55.665-55.553 0 0 6.874 27.706 3.87 32.868-2.229 3.83-5.85 6.523-9.987 8.112-2.075.797-3.681 2.235-4.455 4.611-1.558 4.778.484 7.757 4.033 9.684 5.507 2.991 8.832 8.945 7.978 15.154-1.915 13.91-10.252 22.365-22.398 24.475-16.212 2.814 23.273 72.54-53.046 61.806 0 0-24.891-15.368-10.109-46.409.317 2.694 18.042 18.019 16.659 13.916"
              transform="translate(259.403 417.028)"
            ></path>
            <path
              fill="#004656"
              fillRule="nonzero"
              d="M0-79.94c.824-4.242 7.381-2.81 6.558 1.432-.519 2.672-.18 5.386.106 8.069.459 4.305-6.247 4.644-6.704.362-.353-3.304-.599-6.572.04-9.863M-31.933 36.807c1.824-22.642 39.208-111.49 70.407-153.554-19.043 17.918-44.716 5.632-52.601 52.329-2.09 12.376-7.798 10.096-16.984 28.423-2.589 5.167-3.89 10.873-3.741 16.651.119 4.59 7.46 19.216 8.935 23.591 1.383 4.102-16.342-11.223-16.659-13.916C-57.358 21.372-32.467 36.74-32.467 36.74c.182.025.353.043.534.067"
              transform="translate(259.443 419.449)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.34"
              d="M-66.262 94.506c1.662.223 114.18 18.658 201.053 0"
              transform="scale(1 -1) rotate(70.071 512.871 -18.815)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.34"
              d="M-.224 2.567s17.456-3.257 28.708 0"
              transform="scale(1 -1) rotate(10.304 2185.283 1258.273)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.34"
              d="M-3.001-6.119s8.15-2.667 15.481 0"
              transform="scale(1 -1) rotate(-52.243 -256.4 -439.747)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.34"
              d="M-25.553-4.673S-13.054.37.406-4.673"
              transform="scale(-1 1) rotate(16.671 -1625.14 -576.478)"
            ></path>
            <path
              fill="none"
              fillRule="nonzero"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.34"
              d="M-6.385-9.87s9.275-4.237 21.704 0"
              transform="scale(1 -1) rotate(-65.634 -216.409 -393.96)"
            ></path>
          </g>
        </g>
        <use
          width="81.776"
          height="93.592"
          x="323.635"
          y="104.184"
          transform="translate(24.864 31.593) scale(.99727 .99566)"
          xlinkHref="#_Image3"
        ></use>
        <path
          fill="#E3ECFD"
          fillRule="nonzero"
          d="M-39.94-15.729l-60.854 51.272A497.823 497.823 0 00-39.94 106.65l60.057-52.204A428.627 428.627 0 01-39.94-15.729"
          transform="scale(1 -1) rotate(40.557 478.976 520.512)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-11.073-10.119l-1.872 22.213c.623.01 1.247.02 1.872.028l1.865-22.218c-.622-.006-1.244-.014-1.865-.023"
          transform="scale(1 -1) rotate(84.846 257.962 138.672)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-31.882-30.847c-.668 22.876-1.288 44.098-1.863 63.839l1.863-.03 1.843-63.85c-.614.016-1.228.029-1.843.041"
          transform="scale(1 -1) rotate(88.11 259.72 141.957)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-31.885-30.915c-.666 22.859-1.283 44.066-1.859 63.793.62.006 1.24.01 1.859.013l1.839-63.799c-.613-.001-1.226-.004-1.839-.007"
          transform="scale(1 -1) rotate(88.23 265.64 135.05)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-31.897-31.008l-1.857 63.782c.619.02 1.238.039 1.857.056l1.836-63.782c-.612-.017-1.225-.036-1.836-.056"
          transform="scale(1 -1) rotate(88.348 271.684 128.332)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-31.93-31.105l-1.855 63.802c.618.035 1.236.067 1.855.1l1.836-63.798c-.611-.033-1.223-.068-1.836-.104"
          transform="scale(1 -1) rotate(88.466 277.868 121.803)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-31.98-31.217l-1.858 63.857 1.858.142c.57-19.743 1.181-40.969 1.839-63.848-.613-.049-1.226-.1-1.839-.151"
          transform="scale(1 -1) rotate(88.583 284.192 115.449)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-32.048-31.346l-1.863 63.945c.621.064 1.243.125 1.863.186l1.844-63.929c-.614-.067-1.229-.133-1.844-.202"
          transform="scale(1 -1) rotate(88.697 290.67 109.266)"
        ></path>
        <use
          width="103.789"
          height="112.558"
          x="318.71"
          y="208.75"
          transform="translate(24.864 31.593) scale(.99797 .99609)"
          xlinkHref="#_Image4"
        ></use>
        <path
          fill="#E3ECFD"
          fillRule="nonzero"
          d="M-51.398-29.042l-60.854 51.273a497.877 497.877 0 0060.854 71.107L8.659 41.134a428.634 428.634 0 01-60.057-70.176"
          transform="scale(1 -1) rotate(58.003 463.773 275.807)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-10.863-13.492c-.641 7.602-1.265 15.004-1.871 22.213.624.009 1.247.02 1.871.028l1.865-22.219a386.55 386.55 0 01-1.865-.022"
          transform="scale(-1 1) rotate(-77.705 -23.492 349.844)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-30.728-40.47l-1.863 63.839 1.863-.031 1.844-63.849c-.616.015-1.23.029-1.844.041"
          transform="scale(-1 1) rotate(-74.444 -26.943 364.939)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-30.709-40.534l-1.858 63.794c.619.006 1.238.009 1.858.013l1.839-63.799a563.67 563.67 0 01-1.839-.008"
          transform="scale(-1 1) rotate(-74.324 -20.256 373.53)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-30.705-40.618l-1.855 63.781c.618.021 1.236.039 1.855.056l1.837-63.781a571.93 571.93 0 01-1.837-.056"
          transform="scale(-1 1) rotate(-74.205 -13.775 382.26)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-30.716-40.724l-1.856 63.802c.62.035 1.238.067 1.856.099l1.836-63.796c-.613-.034-1.225-.069-1.836-.105"
          transform="scale(-1 1) rotate(-74.086 -7.486 391.151)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-30.745-40.849l-1.858 63.856c.618.049 1.239.096 1.858.143l1.838-63.847c-.613-.049-1.226-.1-1.838-.152"
          transform="scale(-1 1) rotate(-73.971 -1.397 400.198)"
        ></path>
        <path
          fill="#757073"
          fillRule="nonzero"
          d="M-30.79-40.997c-.669 22.913-1.289 44.17-1.864 63.944.621.064 1.243.126 1.864.188l1.843-63.93a576.34 576.34 0 01-1.843-.202"
          transform="scale(-1 1) rotate(-73.856 4.507 409.423)"
        ></path>
      </g>
    </g>
    <defs>
      <image
        id="_Image1"
        width="355"
        height="238"
        xlinkHref="data:image/png;base64,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"
      ></image>
      <image
        id="_Image3"
        width="82"
        height="94"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABeCAYAAACw7kPgAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADzUlEQVR4nO2d23LbIBCG/0X4UKfpYXrV93+6TjtN0uZoS2wvBAglctyAZoza/7vwyBjknfUuu2AEoqoAgG9XTvddf23iC9CXAEaT9yZ+DGhfJgBE+ovQRhQQSCyT/rJv5ivFslDHX8Qy/3naTmRoG2QSBa7v73HoDniOhIppWZBSxqXTV71AL+8SaghseOOg8Qs1vgy4Z2+6qTvqVOFbyb/Jw16xb0vuOVXvdFuBi4albhYl/J80DWCv7xQK4OYOmMmkZmO3Edjm3FKcxojA3j4qOgfcPdalRABYW8A2x3qmehAB7Med4NACD7v6BF6CEgGgMYC9fCd4Oije75chdI2YkMUw0JQhIlTkHDTRIt2pquQ1jNC1ZyEqsqMiixiCzeR4j/wtg2tXNqJZGiIiDDaFGJ9+e0XSInNp/FyAd22Si/hZSqMKhXJ4mIvxE5GGXl1GQ0XOQww2jNhlSFSk0iRLoGvPhPG+TUUWMiTkVGQRRvxaAOqxEB9t7M/fDrePZxbmCBcbwcqerndOwlDG3j8BD0912uV2BayOLhSpBC+e/XwBrGydwtYqV0q0yO3GoGMuWYIAjNqFDMozHCHmk3Y8tMgC0nWX5pV65AQidO1ZSBcCG/7PkI8gdW1hJ5lNapGc2M1nHLXrHzxUTOratMhsxlGbfeQsGOoxn1FCTj3mY0auTU3OAl27gLFrM/3JRkbTaEx/8hmNtcksGENV5pPEF/vjl6K2p2IDl1uD9ercUhxHE9+2bVvvczZuE/YmqJN+9wW/QODLJeAqDd1LeToWAOx2LWjdcgSuidQAmUcWoMl6AENNzoNhJpmPpq5daeazEFLXpkVmk9qg4cNKBSSaZB9ZgI5c+4yCLB0dWSTJZhy12UVmM07IzyjI0hlHbVpkAYlrU4/F9HuTTmz2Sd5A3PH1rFL8C3hN0iILiRZJPRaiYYNnarKIMEtuaJJlhD8O7fcbh6vbOiclP+wEm1Xdv3S/+ZTAOhW0lW7Xt4RHJDu/5Md+/WSqjTjNApKz8GPb9QqL2Ou7VkIfyWBTSHBtIwLhQ0v5hGWR6UEhJIPwd0OvSPp3Np3fVtcr8pyiLJsYbPoXWmQJqqq9Ipn+FOHUW+SCliFWiXPBtanIIqJFMtiUMSiSFllER9eeB1VlQj4HDDYzQdeeCQ3BRmS8PwN5Gy70kQCEVplP12E4O9ZA0Go6JfTyAF6gPxQXMky9aVxpgLimKB7KqwAgsU2soslBvZIepitDu+TgXqTt0vukP74C+3biZE+RiZkEfdl++JZnxXrkHvF4XggM/gC4sibg+u2v2QAAAABJRU5ErkJggg=="
      ></image>
      <image
        id="_Image4"
        width="104"
        height="113"
        xlinkHref="data:image/png;base64,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"
      ></image>
    </defs>
  </svg>
);
